(function () {
  'use strict';

  var STORAGE_KEY = 'ecw_attribution_v1';
  var SYNC_KEY = 'ecw_attribution_last_sync_v1';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var SYNC_INTERVAL_MS = 30 * 1000;
  var VALUE_LIMIT = 500;

  var CAPTURE_PARAMS = [
    'gclid',
    'gbraid',
    'wbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_id',
    'utm_term',
    'utm_content',
    'utm_source_platform',
    'gad_campaignid',
    'gad_adgroupid',
    'gad_targetid',
    'gad_product_id',
    'gad_product_partition_id',
    'gad_merchant_id',
    'gad_product_channel',
    'gad_network',
    'gad_device',
    'gad_loc_physical',
    'gad_loc_physical_ms',
    'ecw_paid_click'
  ];

  var ATTR_MAP = {
    gclid: 'ecw_gclid',
    gbraid: 'ecw_gbraid',
    wbraid: 'ecw_wbraid',
    utm_source: 'ecw_utm_source',
    utm_medium: 'ecw_utm_medium',
    utm_campaign: 'ecw_utm_campaign',
    utm_id: 'ecw_utm_id',
    utm_term: 'ecw_utm_term',
    utm_content: 'ecw_utm_content',
    utm_source_platform: 'ecw_utm_source_platform',
    gad_campaignid: 'ecw_gad_campaignid',
    gad_adgroupid: 'ecw_gad_adgroupid',
    gad_targetid: 'ecw_gad_targetid',
    gad_product_id: 'ecw_gad_product_id',
    gad_product_partition_id: 'ecw_gad_product_partition_id',
    gad_merchant_id: 'ecw_gad_merchant_id',
    gad_product_channel: 'ecw_gad_product_channel',
    gad_network: 'ecw_gad_network',
    gad_device: 'ecw_gad_device',
    gad_loc_physical: 'ecw_gad_loc_physical',
    gad_loc_physical_ms: 'ecw_gad_loc_physical_ms',
    ecw_paid_click: 'ecw_paid_click'
  };

  function nowIso() {
    return new Date().toISOString();
  }

  function safeGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return false;
    }
    return true;
  }

  function safeRemove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      return false;
    }
    return true;
  }

  function cleanValue(value) {
    if (value == null) return '';
    return String(value).replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, VALUE_LIMIT);
  }

  function readStored() {
    var raw = safeGet(STORAGE_KEY);
    if (!raw) return {};
    try {
      var parsed = JSON.parse(raw);
      var capturedAt = Date.parse(parsed.ecw_click_captured_at || parsed.captured_at || '');
      if (capturedAt && Date.now() - capturedAt > MAX_AGE_MS) {
        safeRemove(STORAGE_KEY);
        safeRemove(SYNC_KEY);
        return {};
      }
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      safeRemove(STORAGE_KEY);
      return {};
    }
  }

  function writeStored(data) {
    safeSet(STORAGE_KEY, JSON.stringify(data));
  }

  function captureFromLocation() {
    var params = new URLSearchParams(window.location.search || '');
    var captured = {};

    CAPTURE_PARAMS.forEach(function (param) {
      var value = cleanValue(params.get(param));
      if (value) captured[ATTR_MAP[param]] = value;
    });

    if (!Object.keys(captured).length) return readStored();

    var stored = readStored();
    var merged = Object.assign({}, stored, captured);
    merged.ecw_click_landing_page = cleanValue(window.location.href);
    merged.ecw_click_referrer = cleanValue(document.referrer || stored.ecw_click_referrer || '');
    merged.ecw_click_captured_at = nowIso();

    if (
      merged.ecw_gclid ||
      merged.ecw_gbraid ||
      merged.ecw_wbraid ||
      merged.ecw_utm_medium === 'cpc' ||
      merged.ecw_paid_click === '1'
    ) {
      merged.ecw_paid_click = '1';
    }

    writeStored(merged);
    return merged;
  }

  function cartAttributes(data) {
    var attrs = {};
    Object.keys(data || {}).forEach(function (key) {
      var value = cleanValue(data[key]);
      if (key.indexOf('ecw_') === 0 && value) attrs[key] = value;
    });
    return attrs;
  }

  function hasAttribution(attrs) {
    return Boolean(
      attrs.ecw_gclid ||
        attrs.ecw_gbraid ||
        attrs.ecw_wbraid ||
        attrs.ecw_utm_source ||
        attrs.ecw_utm_medium ||
        attrs.ecw_utm_campaign
    );
  }

  function injectCartFormInputs(attrs) {
    if (!hasAttribution(attrs)) return;
    document.querySelectorAll('form[action^="/cart"], form[action*="/cart"]').forEach(function (form) {
      Object.keys(attrs).forEach(function (key) {
        var input = null;
        form.querySelectorAll('input').forEach(function (candidate) {
          if (candidate.name === 'attributes[' + key + ']') input = candidate;
        });
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'attributes[' + key + ']';
          form.appendChild(input);
        }
        input.value = attrs[key];
      });
    });
  }

  function shouldSync(attrs) {
    if (!hasAttribution(attrs)) return false;
    var raw = safeGet(SYNC_KEY);
    if (!raw) return true;
    try {
      var previous = JSON.parse(raw);
      if (previous.hash !== JSON.stringify(attrs)) return true;
      return Date.now() - Number(previous.time || 0) > SYNC_INTERVAL_MS;
    } catch (error) {
      return true;
    }
  }

  function markSynced(attrs) {
    safeSet(SYNC_KEY, JSON.stringify({ hash: JSON.stringify(attrs), time: Date.now() }));
  }

  function syncCartAttributes(force) {
    var attrs = cartAttributes(readStored());
    injectCartFormInputs(attrs);
    if (!force && !shouldSync(attrs)) return Promise.resolve(false);
    if (!hasAttribution(attrs) || !window.fetch) return Promise.resolve(false);

    return window
      .fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ attributes: attrs })
      })
      .then(function (response) {
        if (response.ok) markSynced(attrs);
        return response.ok;
      })
      .catch(function () {
        return false;
      });
  }

  function scheduleSync(force) {
    window.setTimeout(function () {
      syncCartAttributes(force);
    }, 0);
  }

  var latest = captureFromLocation();
  injectCartFormInputs(cartAttributes(latest));
  scheduleSync(false);

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form instanceof HTMLFormElement) {
        injectCartFormInputs(cartAttributes(readStored()));
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target.closest('button, a, input') : null;
    if (!target) return;
    var text = (target.textContent || target.value || '').toLowerCase();
    var name = (target.getAttribute('name') || '').toLowerCase();
    var href = (target.getAttribute('href') || '').toLowerCase();
    if (name === 'checkout' || href.indexOf('/checkout') !== -1 || text.indexOf('checkout') !== -1) {
      injectCartFormInputs(cartAttributes(readStored()));
      scheduleSync(true);
    }
  });

  document.addEventListener('cart:update', function () {
    scheduleSync(true);
  });
})();
